import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

export const ACTIVITY_LOG_REDUCER_NAME = "activity-log";

const initialState = {
  page: 0,
  take: 20,
  totalCount: 0,
  activityLog: [],
};

const activityLogSlice = createSlice({
  name: ACTIVITY_LOG_REDUCER_NAME,
  initialState: initialState,
  reducers: {
    setActivityLog: (state, action) => {
      state.activityLog = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setTake: (state, action) => {
      state.take = action.payload;
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload;
    },
    clearLogs: (state) => {
      state.activityLog = [];
    },
  },
});

export const {
  addActivity,
  setActivityLog,
  setTotalCount,
  clearLogs,
  setPage,
  setTake,
} = activityLogSlice.actions;

export default activityLogSlice.reducer;

export const useSelectPageActivityLog = () => {
  return useSelector((state) => state[ACTIVITY_LOG_REDUCER_NAME].page);
};

export const useSelectTakeActivityLog = () => {
  return useSelector((state) => state[ACTIVITY_LOG_REDUCER_NAME].take);
};

export const useSelectActivityLog = () => {
  return useSelector((state) => state[ACTIVITY_LOG_REDUCER_NAME].activityLog);
};

export const useSelectTotalCountActivityLog = () => {
  return useSelector((state) => state[ACTIVITY_LOG_REDUCER_NAME].totalCount);
};
